import { useLocation } from "react-router-dom";

import { EdgeCase } from "@/components";
import { NewIntakeLayout } from "@/layout";
import {
  formatDate,
  PATIENT_DISQUALIFY_REASONS,
  PATIENT_STATUS,
} from "@/utils";

interface DisqualifiedPatientLocationState {
  patientData: {
    reason: string;
    date: {
      month: number;
      day: number;
      year: number;
    };
  };
}

export const DisqualifiedPatient = () => {
  const location = useLocation();
  const state = location.state as DisqualifiedPatientLocationState;
  const { patientData } = state;

  const getDisqualificationMessage = () => {
    if (patientData.reason === PATIENT_DISQUALIFY_REASONS.NOT_INSULIN) {
      return "because they stated that they were not taking insulin and had not experienced two blood sugar readings below 54 in the previous six months.";
    } else if (patientData.reason === PATIENT_DISQUALIFY_REASONS.NOT_PECOS) {
      return "because the doctor does not have Pecos check.";
    } else {
      return ``;
    }
  };
  return (
    <NewIntakeLayout isEdgeCaseScreen>
      <EdgeCase
        status={PATIENT_STATUS.DISQUALIFIED}
        description={`This patient was disqualified on ${formatDate(patientData?.date) ?? "-"} ${getDisqualificationMessage()}`}
      />
    </NewIntakeLayout>
  );
};
